import React, { useState, useMemo, useEffect } from 'react';
import { ThemeProvider } from "@pixel/core";
import { createInternalTheme } from "@pixel/internal/styles";
import { LocalizationProvider } from '../../../contexts/Localization/LocalizationProvider';
import { LocalizationValues } from '../../../contexts/Localization/LocalizationTypes';
import DomainProvider from '../../../contexts/Domain';
import { ConfirmationDialogServiceProvider } from '@pixel/core/ConfirmationService';
import SnackbarServiceProvider, { useSnackbar } from "@pixel/core/SnackbarService";
import AccessGroupList from './AccessGroupList';
import OdsContext from '../OdsContext';

export const App = (props: any) => {
  const overlayStyling = {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    alignItems: 'center',
    zIndex: '1',
  }

  const theme = createInternalTheme({ darkMode: false, theme: {} });
  const perPageSelectOptions = [{ ariaLabel: "ten", value: 10 }, { ariaLabel: "twenty", value: 20 }, { ariaLabel: "thirty", value: 30 }, { ariaLabel: "fifty", value: 50 }];
  const defaultPageSize = 20;
  const snackBarAutoHideTime = 10000;

  return (
    <React.StrictMode>
      <DomainProvider urls={window.jvUrls}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider locale='en-us' translations={props.translations as LocalizationValues}>
            <OdsContext.Provider value={{ perPageSelectOptions, defaultPageSize, snackBarAutoHideTime }}>
              <SnackbarServiceProvider maxSnack={5}>
                <ConfirmationDialogServiceProvider>
                  <AccessGroupList></AccessGroupList>
                </ConfirmationDialogServiceProvider>
              </SnackbarServiceProvider>
            </OdsContext.Provider>
          </LocalizationProvider>
        </ThemeProvider>
      </DomainProvider>
    </React.StrictMode>
  );
}

export { react2angular } from "../../../lib/react2Angular";
export default App;